import { Injectable } from '@angular/core';
import { User } from '../models/auth.models';
import { getFirebaseBackend } from '../../firebaseBackend/authUtils';
import { getFirebaseBackend as getFirestoreBackend } from "../../firebaseBackend/firestoreUtils";

@Injectable({ providedIn: 'root' })

export class AuthenticationService {

    user: User;

    constructor() {}

    /**
     * Returns the current user
     */
    public currentUser(): User {
        return getFirebaseBackend().getAuthenticatedUser();
    }

    getAuth(){
        return getFirebaseBackend().auth;
    }

    /**
     * Send verification mail
     */
    sendVerificationMail(){
        return getFirebaseBackend().SendVerificationMail().then(()=>{
        })
    }

    updateProfileData(data:any){
        return getFirebaseBackend().updateProfile(data).then((res:any)=>{
            return res;
        })
    }

    /**
     * 
     * @param token 
     * @returns 
     */
    signInWithToken(token){
        return getFirebaseBackend().signInWithToken(token).then((user: any)=>{
            return user;
        })
    }

    /**
     * Logout the user
     */
    logout() {
        // logout the user
        return getFirebaseBackend().logout();
    }


    checkAndGetUserByEmail(email) {
        return getFirestoreBackend().getDocByUniqueProperty("users", "email", email).then((res) => {
            return res
        })
    }

    creatNewUser(uid: string, Data: any) {
        return getFirestoreBackend().createDocumentWithSetIDAndcollectionPath(uid, `/users`, Data).then((res: any) => {
            sessionStorage.setItem('Username', Data.firstName + ' ' + Data.lastName);
        })
    }

    updateUserRecordByDeleteOldOne(oldDoc: any, newUID: string, userData: any) {
        delete userData.email;
        const userOldDocPth = `users/${oldDoc.id}`;
        const newData = { ...userData, ...oldDoc };
        delete newData.id;
        getFirestoreBackend().deleteDocumentByDocPath(userOldDocPth);
        this.creatNewUser(newUID, newData);
    }

    updateProjectUsers(projectsList, newUid: string, oldUid: string) {
        projectsList.forEach(pid => {
            const projectDocPath = `projects/${pid}`;
            getFirestoreBackend().getDocumentByDocPath(projectDocPath).then((project: any) => {
                const projectIndex = project.users.findIndex((obj => obj == oldUid));
                project.users[projectIndex] = newUid;
                delete project.id
                getFirestoreBackend().editDocumentByDocPath(projectDocPath, project);
            })
        });
    }
    updateCompanyUsers(companyList, newUid: string, oldUid: string) {
        companyList.forEach(cid => {
            const companyDocPath = `companies/${cid}`;
            getFirestoreBackend().getDocumentByDocPath(companyDocPath).then((company: any) => {
                const companyIndex = company.users.findIndex((obj => obj == oldUid));
                company.users[companyIndex] = newUid;
                delete company.id
                getFirestoreBackend().editDocumentByDocPath(companyDocPath, company);
            })
        });
    }
}

